module.exports = __webpack_public_path__ + "static/media/titlecard_favepay.ab1c3566.jpg";